<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>

                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                            <p>
                                Lista para revisar y gestionar contraseñas temporales.
                                Crea, revoca o elimina registros.
                            </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Contraseñas Temporales
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Lista y gestiona todas las <b>contraseñas temporales</b> activas o expiradas.
                </div>
            </div>

            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[0,1,2,3]"
                        [typeFilter]="'TemporaryPassword'" (selectionFilterApply)="getList()">
                    </app-status-filters>
                </div>
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nueva Contraseña">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <div class="pt-1 mx-6">
                <app-smart-grid
                    class="bg-white"
                    [data]="dataSource.data"
                    [columnDefs]="columnDefs"
                    [config]="gridConfig"
                    [loading]="false"
                    [totalRecords]="totalItems"
                    (gridReady)="onGridReady($event)"
                    (pageChanged)="onPageChanged($event)"
                    (sortChanged)="onSortChanged($event)">
                </app-smart-grid>
            </div>
        </div>
    </div>

    <app-filter (onFilterEvent)="getList()" (onCleanEvent)="clearFilters()">
        <app-filter-section title="Rango de fechas" [expanded]="true">
            <app-dates-filters [form]="form" [showDateCreationRange]="true"></app-dates-filters>
        </app-filter-section>

        <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
        <app-business-partners-filters [form]="form" [assignedUser]="true" [solicitedUser]="true"
            [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
        </app-filter-section>
  </app-filter>
</mat-sidenav-container>